import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import SurveyList from './SurveyList';
import CreateIEHeader from './CreateIEHeader';
import IELoading from '../IELoading';
import WarningIcon from '../../../containers/WarningIcon';

const Landing = ({ ieStudy }) => {
  if (ieStudy.loading) {
    return <IELoading />;
  }
  if (ieStudy.error && ieStudy.data.length === 0) {
    return (
      <div className="no-study-message">
        <WarningIcon />
        <p>
          There are no Turn-Key Omnibus studies currently assigned to this account.
          Please contact your MRI-Simmons account team for assistance.
        </p>
      </div>
    );
  }

  return (
    <div className="ie--landing">
      <CreateIEHeader />
      {ieStudy.data.length > 0 && <SurveyList /> }
    </div>
  );
};

Landing.propTypes = {
  ieStudy: PropTypes.instanceOf(Object),
};

Landing.defaultProps = {
  ieStudy: {
    loading: true,
    error: false,
    data: [],
  },
};

const mapStateToProps = ({ turnkeyOmnibus }) => ({
  ieStudy: turnkeyOmnibus.ieStudy,
});

export default connect(
  mapStateToProps,
  null
)(Landing);
